<template>
  <div class="videos">
    <div class="video" v-for="(v,index) in videos" :key="index">
      <img class="vbg" :src="v.plink" alt="">
      <div class="controls" @click="play(index)">
        <img class="play" src="/static/img/playvideo.png" alt="">
        <div>{{v.sign}}</div>
      </div>
    </div>
    <div class="shadow" v-show="isplay">
      <div id="vi" class="popup">
        <div class="close" @click="pause"></div>
        <video id="video" class="popupvideo" :src="videos[currentv].vlink" :autoplay="isautoplay" controls @ended="pause"></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      domain: "https://storageapi.oss-cn-zhangjiakou.aliyuncs.com",
      videos: [
        {vlink: "https://storageapi.oss-cn-zhangjiakou.aliyuncs.com/videos/roadtest_pc.mp4",plink:"/static/img/pv4.jpg",sign:"跋山涉水 一往無前"},
        {vlink: "https://storageapi.oss-cn-zhangjiakou.aliyuncs.com/videos/tecnl_pc.mp4",plink:"/static/img/pv1.jpg",sign:"汽車科技 智慧降臨"},
        {vlink: "https://storageapi.oss-cn-zhangjiakou.aliyuncs.com/videos/prod_pc.mp4",plink:"/static/img/pv2.jpg",sign:"靈動優雅 一騎絕塵"},
        {vlink: "https://storageapi.oss-cn-zhangjiakou.aliyuncs.com/videos/using_pc.mp4",plink:"/static/img/pv3.jpg",sign:"活力無限 兩輪前行"}
      ],
      currentv: 0,
      isplay: false,
      isautoplay: false
    }
  },
  mounted(){
    let that = this
    this.$nextTick(function(){
      window.addEventListener("scroll", that.animateTxt);
    })
  },
  beforeDestroy(){
    window.removeEventListener("scroll", this.animateTxt);
  },
  methods: {
    animateTxt(){
      let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
      if(top <= 100){
        this.$emit("hidenav");
      } else {
        this.$emit("shownav");
      }
    },
    play(index){
      this.currentv = index
      this.isplay = true
      this.isautoplay = true
      let video = document.getElementById("video")
      video.currentTime = 0
      video.play()
    },
    pause(){
      this.isplay = false
      this.isautoplay = false
      let video = document.getElementById("video")
      video.pause()
    }
  }
}
</script>

<style lang="less" scoped>
.videos{
  background-color: #000;
  padding-top: 60px;
  .video{
    position: relative;
    font-size: 0;
    .vbg{
      width: 100%;
    }
    .controls{
      position: absolute;
      width: 150px;
      height: 100px;
      text-align: center;
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      color: #fff;
      cursor: pointer;
      .play{
        width: 40%;
        margin-bottom: 15px;
      }
    }
  }
  .shadow{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .8);
    z-index: 200;
    .close{
      position: absolute;
      z-index: 1;
      width: 25px;
      height: 25px;
      top: 30px;
      right: 30px;
      cursor: pointer;
      opacity: .5;
      transition: opacity .3s;
    }
    .close:hover{
      opacity: 1;
    }
    .close::before{
      content: "";
      position: absolute;
      width: 25px;
      height: 0;
      top: 12px;
      border-top: 2px solid #fff;
      transform: rotate(45deg);
    }
    .close::after{
      content: "";
      position: absolute;
      width: 25px;
      height: 0;
      top: 12px;
      border-top: 2px solid #fff;
      transform: rotate(-45deg);
    }
    .popup{
      width: 100%;
      height: 100%;      
      position: relative;
    }
    .popupvideo{
      width: 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tw/video.vue